import { render, staticRenderFns } from "./MyCart.vue?vue&type=template&id=5f1513fb&scoped=true"
import script from "./MyCart.vue?vue&type=script&lang=js"
export * from "./MyCart.vue?vue&type=script&lang=js"
import style0 from "./MyCart.vue?vue&type=style&index=0&id=5f1513fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1513fb",
  null
  
)

export default component.exports